import { render, staticRenderFns } from "./DialogAddUser.vue?vue&type=template&id=53675b3b"
import script from "./DialogAddUser.vue?vue&type=script&lang=js"
export * from "./DialogAddUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports